import React from 'react';
import { observer } from 'mobx-react';
import { WeaDatePicker } from 'ecCom';

interface Props {
    editable?: boolean;
    value?: string;
    valueSpan?: string;
    viewAttr:string;
    onChange: (string) => void;
    ecId?:string;
    type?:string;
}

export default observer((props: Props) => {
    const {value,onChange,viewAttr,type } = props;
    if(type == '402' || type == '403'){
        return (
            <div style={{float:'left'}}>
                <WeaDatePicker ecId={`${props && props.ecId || ''}_WeaDatePicker@wxurjl`} noInput
                    value={value}
                    viewAttr={viewAttr}
                    format={type =='402'? 'YYYY':'YYYY-MM'}
                    onChange={onChange}
                />
            </div>
        )
    }else{
        return (
            <div style={{float:'left'}}>
                <WeaDatePicker ecId={`${props && props.ecId || ''}_WeaDatePicker@wxurjl`} noInput
                    value={value}
                    viewAttr={viewAttr}
                    onChange={onChange}
                />
            </div>
        )
    }
    
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/WeaDatePicker.tsx